import { swiperRegister, Swiper } from "@ml/swiper/swiper";

swiperRegister();

const swiperType1 = Swiper({
    el: "swiper-container.swiper-slide-type-1",
    options: {
        slidesPerView: 1.5,
        spaceBetween: 20,
        centeredSlides: true,
        speed: 500,
        loop: true,
        // pagination: {
        //     clickable: true,
        // },
        breakpoints: {
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
        autoplay: {
            delay: 3000,
        },
    },

    el: "swiper-container.swiper-slide-type-5",
    options: {
        slidesPerView: 2,
        spaceBetween: 12,
        centeredSlides: true,
        speed: 500,
        loop: true,
        // pagination: {
        //     clickable: true,
        // },
        breakpoints: {
            768: {
                slidesPerView: 4,
            },
        },
        autoplay: {
            delay: 3000,
        },
    },
});
